// @ts-nocheck
import React from "react";
import {
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FilterDrawerProps } from "../../Types/types";
import NoSubCategoriesMessage from "./NoSubCategoriesMessage";
import useDarkMode from "../../hooks/useDarkMode";

interface EnhancedFilterDrawerProps extends FilterDrawerProps {
  isSubCategoryDrawer?: boolean;
}

const FilterDrawer: React.FC<EnhancedFilterDrawerProps> = ({
  open,
  onClose,
  categories,
  subCategories,
  selectedCategories,
  selectedSubCategories,
  onCategorySelect,
  onSubCategorySelect,
  isSubCategoryDrawer,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

  const { colorTheme } = useDarkMode();
  const isDarkMode = theme === "dark";

  const handleCategorySelect = (categoryId: string) => {
    const newSelectedCategories = selectedCategories.includes(categoryId)
      ? []
      : [categoryId];

    onCategorySelect(newSelectedCategories);

    if (newSelectedCategories.length === 0) {
      onSubCategorySelect([]);
    }

    if (newSelectedCategories !== selectedCategories) {
      onSubCategorySelect([]);
    }
  };

  const handleSubCategorySelect = (subCategoryId: string) => {
    const newSelectedSubCategories = selectedSubCategories.includes(
      subCategoryId
    )
      ? []
      : [subCategoryId];

    onSubCategorySelect(newSelectedSubCategories);
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isSmallScreen ? "100%" : 384,
          marginLeft: isLargeScreen || isMediumScreen ? "auto" : 0,
        },
      }}
    >
      <div className="w-full h-full dark:bg-darkSecondaryBackground bg-white p-2">
        <Box display="flex" justifyContent="flex-end">
          <button onClick={onClose} className="dark:text-white p-2">
            <CloseIcon />
          </button>
        </Box>
        <Box
          sx={{
            overflowY: "auto",
            flexGrow: 1,
          }}
        >
          <Box
            sx={{
              maxHeight: "45vh",
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            {categories.map((category) => {
              const isSelected = selectedCategories.includes(
                category.id.toString()
              );
              return (
                <button
                  key={category.id}
                  onClick={() => handleCategorySelect(category.id.toString())}
                  className={`w-full py-3 mb-2 px-4 rounded font-sans
                  ${
                    isSelected
                      ? "bg-purple text-white"
                      : "bg-white text-gray-900"
                  }
                  text-sm capitalize font-light mb-2 shadow-none
                  ${
                    isSelected ? "hover:lightPurple" : "hover:bg-gray-200"
                  } border border-gray transition-colors duration-200`}
                >
                  {category.name}
                </button>
              );
            })}
          </Box>
          {isSubCategoryDrawer &&
            selectedCategories.length > 0 &&
            subCategories.length === 0 && <NoSubCategoriesMessage />}
          <Box
            sx={{
              maxHeight: "45vh",
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
            mt={2}
          >
            {subCategories.map((subCategory) => {
              const isSelected = selectedSubCategories.includes(
                subCategory.id.toString()
              );
              return (
                <button
                  key={subCategory.id}
                  onClick={() =>
                    handleSubCategorySelect(subCategory.id.toString())
                  }
                  className={`w-full py-3 mb-2 px-4 rounded font-sans
                    ${
                      isSelected
                        ? "bg-purple text-white"
                        : "bg-white text-gray-900"
                    }
                    text-sm capitalize font-light mb-2 shadow-none
                    ${
                      isSelected ? "hover:lightPurple" : "hover:bg-gray-200"
                    } border border-gray transition-colors duration-200`}
                >
                  {subCategory.name}
                </button>
              );
            })}
          </Box>
        </Box>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
